import { Box } from "@mui/material";
import { SiteSelector } from "empower-energy-owner-components";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedSite } from "actions/profile";
import { clearSites } from "actions/site";
import { setWindow } from "actions/page";
import SiteSelectorLoader from "components/Loader/SiteSelectorLoader";

const SiteSelect = () => {
  const dispatch = useDispatch();
  const profile = useSelector((state) => state.profile);
  const loading = useSelector((state) => state.profile?.loading);

  const onChange = (e) => {
    dispatch(clearSites());
    dispatch(setSelectedSite(e.target.value));
    dispatch(setWindow("day"));
  };

  return (
    <>
      {loading ? (
        <SiteSelectorLoader />
      ) : (
        profile?.sites?.length > 1 &&
        <Box mb={1}>
          <SiteSelector
            options={profile?.sites}
            value={profile?.selectedSite}
            onChange={onChange}
          />
        </Box>
      )}
    </>
  );
};

export default SiteSelect;
